.list {
  display: inline;
  margin: 0;
  padding: 0;
  list-style: none;
}

.item {
  display: inline;
  margin: 0;
  padding: 0;
  list-style: none;
}

.item::before {
  display: none;
  content: "";
}

.separator {
  margin-left: var(--eg-theme-space-xs);
  margin-right: var(--eg-theme-space-xs);
}
